import { Trans, useTranslation } from 'next-i18next';
import { StrongText } from '@/components/StrongText';
import { DialogBody } from '@/ui_v3/components/dialog/dialog';
import { AiGenerating } from '@/views/build/modal/BuildAiModal/components/AiGenerating';
export const Pending = ({
  prompt
}: {
  prompt: string;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <DialogBody className="h-[682px]" data-sentry-element="DialogBody" data-sentry-component="Pending" data-sentry-source-file="Pending.tsx">
      <AiGenerating imageSrc="/assets/ai_generating_v2.webp" prompt={prompt} description={<Trans t={t} i18nKey={'build:ai.generate.similarQuiz'} components={{
      Comp: <StrongText className={'text-strong'} text={t('build:ai.generateDescription.accent')} />
    }} />} data-sentry-element="AiGenerating" data-sentry-source-file="Pending.tsx" />
    </DialogBody>;
};